/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import moment from 'moment';
import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import { getAnalyticReportCsvReportFromApi, gotAnalyticReportCsvReportFromApi, gotErrorFromAnalyticReportCsvReportApi } from '../../duck/legado/analyticReportCsv';
import { SendLoginTokenAuth } from '../tokens';

export default function getAnalyticReportCsv(
  initialDate: string,
  finalDate: string,
  partner: string
) {
  return (dispatch: any) => {
    dispatch(getAnalyticReportCsvReportFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/analitico/contabil/${partner}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotAnalyticReportCsvReportFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromAnalyticReportCsvReportApi);
      });
  }
}